import { noop } from 'lodash';
import React from 'react';

export type SwitchChangeHandler = (
  checked: boolean,
  evt: React.SyntheticEvent
) => void;

interface Props {
  disabled: boolean;
  on: boolean;
  onChange: SwitchChangeHandler;
}

class Switch extends React.Component<Props> {
  static defaultProps = {
    onChange: noop,
    disabled: false,
    on: false,
  };

  handleClick = (evt: React.SyntheticEvent): void => {
    const { on, onChange, disabled } = this.props;
    if (!disabled) {
      onChange(!on, evt);
    }
  };

  render(): React.ReactNode {
    const { on, disabled } = this.props;
    return (
      <div>
        {on ? (
          <div
            onClick={this.handleClick}
            style={{
              width: '56px',
              height: '30px',
              borderRadius: '15px',
              backgroundColor: '#008636',
            }}
          >
            <div
              style={{
                width: '26px',
                height: '26px',
                boxShadow: '0 0 8px 0 rgba(0, 36, 14, 0.24)',
                backgroundColor: '#ffffff',
                position: 'relative',
                top: '2px',
                bottom: '2px',
                left: 'calc(100% - 2px - 26px)',
                borderRadius: '50%',
              }}
            />
          </div>
        ) : (
          <div
            onClick={this.handleClick}
            style={{
              width: '56px',
              height: '30px',
              borderRadius: '15px',
              backgroundColor: '#8c9396',
            }}
          >
            <div
              style={{
                width: '26px',
                height: '26px',
                boxShadow: '0 0 8px 0 rgba(0, 36, 14, 0.24)',
                backgroundColor: '#ffffff',
                position: 'relative',
                top: '2px',
                bottom: '2px',
                left: '2px',
                borderRadius: '50%',
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Switch;
